import lozad from 'lozad';
import accessibilityHelper from '../util/AccessibilityHelper';
import initContentTables from '../util/contentTables';

export default {
    init() {
        // JavaScript to be fired on all pages
        initContentTables();

        const search = {
            searchBtn: false,
            searchIpt: false,
            closeBtn: false,

            init() {
                this.searchBtn = document.querySelector("#site-search");
                this.searchIpt = document.querySelector("#search-overlay input");
                this.closeBtn = document.querySelector(".search-overlay__close");

                if (this.searchBtn) {
                    this.addClickHandlers();
                    this.addFocusTrapping();
                }
            },
            addClickHandlers() {
                this.searchBtn.addEventListener("click", function () {
                    let active = !document.body.classList.contains('search-open');
                    document.body.classList.toggle('search-open');

                    if (active) {
                        setTimeout(function () {
                            $("#global-search")
                                .val("")
                                .trigger("focus");
                        }, 500)
                    } else {
                        document.activeElement.blur();
                    }
                });

                this.closeBtn.addEventListener("click", () => {
                    document.body.classList.remove("search-open");
                });
            },
            addFocusTrapping() {
                const elements = ['.search-overlay__close', '#global-search'];
                const overlay = document.querySelector("#search-overlay");

                const firstFocusableElement = overlay.querySelector(elements);
                const focusableContent = overlay.querySelectorAll(elements);
                const lastFocusableElement = focusableContent[focusableContent.length - 1];

                overlay.addEventListener('keydown', function (e) {
                    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                    if (!isTabPressed) {
                        return;
                    }

                    if (e.shiftKey) { // if shift key pressed for shift + tab combination
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus(); // add focus for the last focusable element
                            e.preventDefault();
                        }
                    } else { // if tab key is pressed
                        if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                            firstFocusableElement.focus(); // add focus for the first focusable element
                            e.preventDefault();
                        }
                    }
                })
            },
        };

        search.init();

        /**
         * Post carousels (news, projects) — each mirrors its archive grid, showing
         * 1/2/3 whole cards at the same breakpoints rather than a peeking slide.
         * The label comes off the element so the arrows announce the right posts.
         */
        $('.js-post-carousel').each(function () {
            const $carousel = $(this);
            const label = $carousel.data('carousel-label') || 'items';

            /**
             * Circular nav buttons matching the listing pagination style, centred on
             * the card image so they never sit over a category chip or the copy below.
             * The card image is 282/448 of the card width, and the card is a third /
             * half / all of the carousel width at each step, so its midpoint is a
             * fixed share of the carousel's own width — hence cqw, not a percentage of
             * the (taller on news) card height.
             */
            const navBtn = 'absolute top-[31.5cqw] md:top-[15.7cqw] lg:top-[10.5cqw] -translate-y-1/2 z-10 inline-flex items-center justify-center w-10 h-10 rounded-full border-2 border-brand-graphite bg-white text-brand-graphite cursor-pointer transition-colors hover:bg-brand-emerald hover:border-brand-emerald [&.slick-disabled]:opacity-40 [&.slick-disabled]:pointer-events-none';
            const leftChevron = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>';
            const rightChevron = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>';

            $carousel.slick({
                arrows: true,
                prevArrow: '<button type="button" aria-label="Previous ' + label + '" class="' + navBtn + ' left-3">' + leftChevron + '</button>',
                nextArrow: '<button type="button" aria-label="Next ' + label + '" class="' + navBtn + ' right-3">' + rightChevron + '</button>',
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                // Skip slick's extra per-slide row wrapper so the card can stretch to
                // the tallest slide in view.
                rows: 0,
                accessibility: true,
                focusOnChange: true,
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: 2 } },
                    { breakpoint: 768, settings: { slidesToShow: 1 } },
                ],
            });
        });

        /**
         * Construction partners — tabbed logo panels.
         *
         * Mirrors the homepage clients/partners carousel's panel switching, but
         * deliberately omits the per-tab background/title/body colour cycling: only
         * the panel fade and the active tab button state change here.
         */
        document.querySelectorAll('.js-framework-partners').forEach((section) => {
            const panels = Array.from(section.querySelectorAll('[data-panel]'));
            const tabs = Array.from(section.querySelectorAll('[data-tab]'));
            if (panels.length < 2 || !tabs.length) return;

            const activate = (key) => {
                panels.forEach((panel) => {
                    const isActive = panel.dataset.panel === key;
                    panel.classList.toggle('opacity-100', isActive);
                    panel.classList.toggle('opacity-0', !isActive);
                    panel.classList.toggle('pointer-events-none', !isActive);
                });

                tabs.forEach((btn) => {
                    const isActive = btn.dataset.tab === key;
                    btn.classList.toggle('bg-brand-forest', isActive);
                    btn.classList.toggle('text-white', isActive);
                    btn.classList.toggle('bg-neutrals-100', !isActive);
                    btn.classList.toggle('text-brand-forest', !isActive);
                });
            };

            tabs.forEach((btn) => {
                btn.addEventListener('click', () => activate(btn.dataset.tab));
            });
        });

        /**
         * Lazy load deferred images
         */
        const observer = lozad();
        observer.observe();

        /**
         * Load extra accessibility updates
         */
        new accessibilityHelper();

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
    };
